module.exports = __webpack_public_path__ + "img/favicon.ff2d579d.png";